import React from "react";
import { SubscriptionListComponent } from "./subscription-list.component";

export const SubscriptionListPage = () => <SubscriptionListComponent />;
